import React from "react";
import { Button } from "../../../components/ui/Button";
import { useTranslation } from "react-i18next";

import {
    useEmergencyStatus,
    useDeactivateEmergency,
} from "../../../queries/emergency";

const EmergencyBanner = () => {
    const { t } = useTranslation();
    const { data } = useEmergencyStatus({ refetchInterval: 15000 });
    const deactivate = useDeactivateEmergency();

    if (!data?.active) return null;

    return (
        <div
            className="w-full px-4 py-2 flex flex-wrap items-center justify-between gap-3 border-bottom"
            style={{
                background: "linear-gradient(90deg, #b91c1c 0%, #dc2626 100%)",
                color: "#fff",
            }}
            role="alert"
        >
            <div className="flex items-center gap-3">
                <span className="text-xl">🚨</span>
                <div className="leading-tight">
                    <div className="font-bold uppercase tracking-wide text-sm">
                        {t("emergency.banner_mode_active")}
                    </div>
                    <div className="text-xs opacity-90">
                        {t("emergency.banner_safe_content")}
                    </div>
                </div>
            </div>

            <Button
                label={deactivate.isLoading ? t("emergency.resuming") : t("emergency.resume_normal")}
                onClick={() => deactivate.mutate()}
                disabled={deactivate.isLoading}
                className="p-button-sm p-button-success"
            />
        </div>
    );
};

export default EmergencyBanner;
